import {getXAxis} from "@/assets/js/get-xaxis";

export const getVolumeStatisticsConfig = (data) => {
	const width = document.body.clientWidth
	let is_w = width / 1920;is_w=is_w>1?1:is_w
	const xAxis = getXAxis()
	const yAxis = [

		{
			name: '交易额              ',
			data: 'value',
			min: 0,
			max: 1,
			interval: 0.1,
			axisLine: {
				style: {
					stroke: 'rgba(0,0,0,0)',
					lineWidth: 1
				}
			},
			splitLine: {
				style: {
					stroke: 'rgba(255,255,255,0.3)',
				}
			},
			axisLabel: {
				formatter: '{value} 万元',
				style: {
					fill: '#cdcac3',
					fontSize: is_w*18
				}
			},
			//nameLocation:'end',
			//nameGap:12,

			nameTextStyle: {
				fill: '#fff',
				fontSize: is_w*18,
				align:'right',

			},
			axisTick: {
				show: false
			}
		},
		{
			name: '               订单数',
			data: 'value',
			position: 'right',
			min: 0,
			max: 10,
			interval: 1,
			splitLine: {
				show: false
			},
			axisLine: {
				style: {
					stroke: 'rgba(0,0,0,0)',
					lineWidth: 1
				}
			},
			axisLabel: {
				formatter: '{value} 单',
				style: {
					fill: '#cdcac3',
					fontSize: is_w*18
				}
			},
			nameTextStyle: {
				fill: '#fff',
				fontSize: is_w*18
			},
			axisTick: {
				show: false
			}
		}

	]
	let max1 = 0
	let max2 = 0
	const series = [
		{
			name: '交易额',
			data: [],
			type: 'line',
			lineStyle: {
				stroke: '#e8c072',
				lineWidth: 2
			},
			smooth: true,
			linePoint: {
				style: {
					stroke: '#f19745'
				}
			},
			lineArea: {
				show: true,
				gradient: ['#e8c072', 'rgba(232,192,114,0)']
			},
			animationCurve: 'easeOutBounce'
		},
		{
			name: '订单数',
			yAxisIndex: 1,
			data: [],
			type: 'bar',
			barWidth: '40%',
			gradient: {
				//color: ['#e4ac3e', '#3b3734'],
				color: ['#e4ac3e', 'rgba(247,191,80,0.7)', 'rgba(247,191,80,0.5)', 'rgba(247,191,80,0.05)'],
			},
			animationCurve: 'easeOutBounce'
		},

	]
	xAxis.data.forEach(date => {
		const item = data.find(item => item.date === date)
		if (item) {
			let order_amount = item.order_amount / 10000
			if (order_amount > max1) {
				max1 = order_amount
			}

			let order_num = Number(item.order_num)
			if (order_num > max2) {
				max2 = order_num
			}
			series[0].data.push(order_amount)
			series[1].data.push(order_num)
		} else {
			series[0].data.push(0)
			series[1].data.push(0)
		}
	})
	yAxis[0].max = max1
	yAxis[0].interval = yAxis[0].max / 5
	yAxis[1].max = Math.ceil(max2)
	yAxis[1].interval = Math.ceil(yAxis[1].max / 10) * 2
	return {xAxis, series, yAxis}
}
